import {defineAsyncComponent} from 'vue'

export const AppComponents = {
    'script-mobile-menu': defineAsyncComponent(() => import('./Menus/MobileMenuView.vue')),

}
